import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocalePath } from '../i18n/hooks';

function Footer() {
  const { t } = useTranslation('common');
  const localePath = useLocalePath();

  return (
    <footer className="site-footer bg-dark text-light py-4 mt-0">
      <Container>
        <Row>
          <Col md={4}>
            <h5>{t('site.name')}</h5>
            {/* <p>{t('site.tagline')}</p> */}
            <p>{t('footer.operatingAreaTitle')}: {t('footer.operatingAreaCities')}</p>
          </Col>
          <Col md={4}>
            <h5>{t('footer.quickLinks')}</h5>
            <ul className="list-unstyled">
              {/* <li><Link to={localePath('/')} className="text-light">{t('nav.home')}</Link></li> */}
              {/* <li><Link to={localePath('/contact')} className="text-light">{t('nav.contact')}</Link></li> */}
              <li>
                <a
                  href="https://www.linkedin.com/company/see3eye"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-light"
                >
                  Connect
                </a>
              </li>
            </ul>
          </Col>
          <Col md={4}>
            <h5>{t('footer.contactInfo')}</h5>
            <p>
              {t('contact.info.emailLabel')}: {t('contact.info.email')}<br />
              {t('contact.info.phoneLabel')}: {t('contact.info.phone')}<br />
              {/* {t('contact.info.addressSingleLine')} */}
            </p>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col className="text-center">
            <p className="mb-0">&copy; 2026 {t('site.name')}. {t('footer.rights')}</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
